import { useEffect } from 'react';
import gtmService from '../../../../../utils/gtm';
import { useRootSelector } from '../../../../../store/hooks';
import {
  selectPricingProductsForGTM,
  selectSitePricingProductsMeta,
} from '../../../store/features/products';
import { useDivisionGTM } from '../useDivisionGTM';
import { PricingProductType } from '../../../store/features/products/types';

export const useSelectPackageGTM = () => {
  const productsForGTM = useRootSelector(selectPricingProductsForGTM);
  const { divisionId, divisionInfrontBusinessUnit, divisionName } =
    useRootSelector(selectSitePricingProductsMeta);
  const shouldPushDataToGTM = productsForGTM.length > 0;

  useDivisionGTM({
    divisionId,
    divisionInfrontBusinessUnit,
    divisionName,
    disablePushDataToGTM: !shouldPushDataToGTM,
  });

  useEffect(() => {
    if (shouldPushDataToGTM) {
      gtmService.pushProductDetails(
        productsForGTM as unknown as PricingProductType,
      );
    }
    // eslint-disable-next-line
  }, []);
};
